import { render, staticRenderFns } from "./Savings.vue?vue&type=template&id=3896d365&scoped=true&"
import script from "./Savings.vue?vue&type=script&lang=js&"
export * from "./Savings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896d365",
  null
  
)

export default component.exports